// Polyfills
import "@babel/polyfill";
import "lazysizes";
import "cookieconsent";
import "alpinejs";

import timeline from './alpine-modules/timeline.js';
import projector from './alpine-modules/projector.js';
import toggle from './alpine-modules/toggle.js';
import edgeBox from './alpine-modules/edgeBox.js';
import relativeHeightFix from "./alpine-modules/relativeHeightFix.js";
import masonry from "./alpine-modules/masonry.js";
import slideshow from "./alpine-modules/slideshow.js";
import expandingColumns from "./alpine-modules/expandingColumns.js";
import { init } from "lazysizes";

window.cookieconsent.initialise({
    palette: {
        popup: {
            background: "#cfcbff",
            text: "#090b11"
        },
        button: {
            background: "#090b11",
            text: "#FFFFFF",
            borderRadius: "22px",
        }
    },
    showLink: true,
    theme: "classic",
    content: {
        message:
            "Dette nettstedet bruker cookies for å sikre at du får den beste opplevelsen på nettstedet vårt.",
        dismiss: "OK",
        link: "Detaljer",
        href: "/personvern"
    }
});

// A script that makes all anchor-tags scroll smoothly
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const href = this.getAttribute('href');
        const el = document.querySelector(href);
        if (el) {
            console.log('bruh moment');
            const yOffset = -100;
            const winOffset = window.pageYOffset;
            const elTop = el.getBoundingClientRect().top;
            const y = elTop + winOffset + yOffset;
            window.scrollTo({
                top: y,
                behavior: 'smooth'
            });
        }
    });
});

// Application files
window.timeline = timeline;
window.projector = projector;
window.toggle = toggle;
window.edgeBox = edgeBox;
window.relativeHeightFix = relativeHeightFix;
window.masonry = masonry;
window.slideshow = slideshow;
window.expandingColumns = expandingColumns

window.spanEdge = function(options = {}) {
    const defaults = {
        reverse: false,
        ...options
    }


    return {
        init() {
            const { img, parent, child } = this.$refs;
            const aspect = img.naturalHeight / img.naturalWidth;
            const spanWidth = this.getSpanWidth();
            const h = spanWidth * aspect;
            parent.style.height = h + 'px'
            child.style.width = spanWidth + 'px';

            ['resize', 'load'].forEach(key => {
                window.addEventListener(key, () => {
                    this.resize();
                })
            })
        },
        getSpanWidth() {
            const { reverse } = defaults;
            if (reverse) {
                return this.$refs.parent.offsetLeft + this.$refs.parent.offsetWidth;
            } else {
                return document.documentElement.offsetWidth - this.$refs.parent.offsetLeft;
            }
        },
        resize() {
            const { reverse: isReverse } = defaults;
            const {parent, child} = this.$refs;
            parent.style.height = child.offsetHeight + 'px';
            if (!isReverse) {
                const left = this.$refs.parent.offsetLeft;
                const width = document.documentElement.offsetWidth;
                const actual = width - left;
                this.$refs.child.style.width = actual + 'px';
            } else {
                const { parent, child } = this.$refs;
                child.style.right = '0';
                const right = parent.offsetLeft + parent.offsetWidth;
                const width = document.documentElement.offsetWidth;
                const actual = right;
                child.style.width = actual + 'px';
            }
        }
    }
}

window.pagination = function(perPage = 10, total) {
    return {
        loading: false,
        hasMorePages: true,
        currentPage: 1,
        perPage: perPage,
        totalPages: total,
        async loadMore() {
            this.loading = true;
            const offset = this.currentPage * this.perPage;

            const data = await fetch(`/unwired/ajax?offset=${offset}`)
            const text = await data.text();
            if (!!text.trim()) {
                this.currentPage++;
                const doc = document.querySelector('#js-list');
                doc.insertAdjacentHTML('beforeend', text);
                window.dispatchEvent(new Event('mason'));
            } else {
                this.hasMorePages = false
            }
            this.loading = false;
        }
    }
}

window.logos = function() {
    return {
        entries: [],
        visibleLogos: [],
        limit: 12,
        timeout: 1200,
        init() {
            fetch('/logos.json')
                .then(response => response.json())
                .then(json => {
                    const [logos] = json.data;
                    this.entries = logos.logos;
                    this.entries = this.entries.map(entry => {
                        const { relatedProjectEntry, siteLink } = entry;
                        const href = relatedProjectEntry ? relatedProjectEntry : siteLink;
                        return {
                            ...entry,
                            href
                        }
                    })
                    this.visibleLogos = this.entries.slice(0, this.limit);

                    const unqiueLogos = new Set([...this.entries.map(entry => entry.image.id)]);

                    if (this.entries.length > this.limit && unqiueLogos.size > this.limit) {
                        setInterval(() => this.swapRandomLogo(), this.timeout);
                    }
                })
                .catch(error => {
                    console.log('uh oh error', error)
                })
        },

        swapRandomLogo() {
            let replacing = this.visibleLogos[Math.floor(Math.random() * this.visibleLogos.length)];
            let replacer = this.entries[Math.floor(Math.random() * this.entries.length)];

            // Retry until we don't get the same logo or one we already have
            if (replacing.image.id === replacer.image.id || this.visibleLogos.find((l) => l.image.id === replacer.image.id)) {
                return this.swapRandomLogo();
            } else {
                let replacingIndex = this.visibleLogos.findIndex((l) => l.image.id === replacing.image.id);

                this.visibleLogos.splice(replacingIndex, 1, replacer);
            }
        }
    }
}

window.dropdown = function() {
    return {
        open: false,
        init() {
            const dropdownContent = document.querySelector('.dropdown__content');
            const dropdownToggle = document.querySelector('.dropdown__toggle');

            document.addEventListener('click', event => {
                
                if (this.open && !dropdownToggle.contains(event.target) && !dropdownContent.contains(event.target)) {
                    this.off();
                }
            })
        },
        toggle() {
            this.open = !this.open;
        },
        off() {
            this.open = false;
        }
    }
}

window.listing = function() {
    return {
        entries: [],
        init() {
            fetch('/articles.json')
                .then(response => response.json())
                .then(response => {
                    this.entries = response.data;
                    console.log(response.data)
                });
        }
    }
}

window.unwiredForm = function(thanks, error) {
    return {
        thanks,
        error,
        submit() {

            const input = this.$el.querySelector('#email');
            const submitButton = this.$el.querySelector('input[type="submit"]');
            const email = input.value;
            const csrfToken = this.$el.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value;
            const audienceId = this.$el.querySelector('input[name="audienceId"]').value

            if (!email) {
                alert('Please enter a valid email');
                return;
            }
            let data = {
                audienceId,
                'CRAFT_CSRF_TOKEN': csrfToken,
                email
            };
            submitButton.disabled = true;
            fetch(`/actions/mailchimp-subscribe/audience/subscribe`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json"
                },
                body: JSON.stringify(data)
            }).then(response => response.json())
                .then(response => {
                    if (response.success) {
                        alert(this.thanks)
                    } else {
                        alert(this.error)
                    }
                    submitButton.disabled = false;
                    input.value = "";
                });
        }
    }
}

window.emailGate = function() {
    return {
        submit() {
            const csrfToken = this.$el.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value;
            const input = this.$el.querySelector('#email');
            const submitButton = this.$el.querySelector('input[type="submit"]');
            const email = input.value;
            const entryId = this.$el.dataset.emailGateEntryId;
            const audienceId = this.$el.querySelector('input[name="audienceId"]').value

            const data = {
                audienceId,
                email,
                consent: true,
                'CRAFT_CSRF_TOKEN': csrfToken,
            };

            
            submitButton.disabled = true;
            fetch(`/actions/mailchimp-subscribe/audience/subscribe`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Accept": "application/json"
                },
                body: JSON.stringify(data)
            })
            
            .then(response => response.json())
                .then(response => {
                    const { success } = response;
                    if (!success) {
                        alert('Something went wrong');
                        return;
                    }

                    // If we are still here fetch downloads
                    return this.fetchDownloads(entryId)
                })
                .then(response => response.text())
                .then(response => {
                    this.insertHtml(response);
                    document.querySelector("[data-email-gate-form]").outerHTML = "";
                })
                .catch(() => {
                    alert('Something went wrong')
                })
                .finally(() => submitButton.disabled = false)

        },
        fetchDownloads(entryId) {
            const params = { 'eid': entryId };

            return fetch('/ajax/ajax-downloads?' + new URLSearchParams(params), {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
        },
        insertHtml(html) {
            document.querySelector('[data-email-gate-container').insertAdjacentHTML('beforeend', html)
        }
    }
}